export default __webpack_public_path__ + "static/media/lixeira-icon.ce68f1bf.svg";